import { Directive, HostListener } from '@angular/core';
import { formatPhone } from 'src/app/data/utils/phone.utils';

@Directive({
  selector: '[appPhoneFormat]',
})
export class PhoneFormatDirective {
  constructor() {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const input = event.target;

    let value = formatPhone(input.value);
    if (value.length === 1) {
      value = '';
    }

    input.value = value;
  }
}
